import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { AddOutcomeActionModalPage } from './add-outcome-action-modal.page';

const routes: Routes = [
  {
    path: '',
    component: AddOutcomeActionModalPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes)
  ],
  declarations: [AddOutcomeActionModalPage]
})
export class AddOutcomeActionModalPageModule {}
